export default __webpack_public_path__ + "./images/closeRound.b8a57fec.svg";